import map from 'ramda/src/map';
import values from 'ramda/src/values';
import {
  IMPORT_SERVICES,
} from '../../services/constants';
import {
  UPDATE_SERVICE_FILTER,
} from '../constants';

const transformToFilter = map(item => ({
  id: item.id,
  title: item.name,
  checked: true,
  type: 'service',
}));

const serviceFilters = (state = [], action) => {
  switch (action.type) {
    case IMPORT_SERVICES:
      return transformToFilter(values(action.response.entities.services));
    case UPDATE_SERVICE_FILTER:
      return state.map((filter) => {
        if (filter === action.payload) {
          filter.checked = !filter.checked;
        }
        return filter;
      });
    default:
  }
  return state;
};

export default serviceFilters;
